/* ============================================
   Lorimer Landing Page JS -- v3
   Quiz, scroll, FAQ, email capture,
   distance-based calculator (Roebling-identical),
   guide capture (Klaviyo)
   ============================================ */

/* --- Size Quiz --- */
function lorimerQuizSelect(btn) {
  var siblings = btn.parentElement.querySelectorAll('.llp-quiz__opt');
  for (var i = 0; i < siblings.length; i++) {
    siblings[i].classList.remove('is-active');
  }
  btn.classList.add('is-active');
}

function lorimerQuizResult() {
  var heightEl = document.querySelector('[data-step="height"] .llp-quiz__opt.is-active');
  var styleEl = document.querySelector('[data-step="style"] .llp-quiz__opt.is-active');
  var colorEl = document.querySelector('[data-step="color"] .llp-quiz__opt.is-active');

  if (!heightEl || !styleEl || !colorEl) {
    alert('Please select an option for each step.');
    return;
  }

  var height = heightEl.getAttribute('data-value');
  var color = colorEl.getAttribute('data-value');

  var sizeMap = {
    'under-50': { size: '14" / Small',   code: 'S', desc: 'Perfect for riders 4\'10" to 5\'0". The 14" frame keeps you low and confident.' },
    '50-54':    { size: '16" / Medium',   code: 'M', desc: 'The most popular Lorimer size. Ideal for riders 5\'1" to 5\'4".' },
    '55-57':    { size: '18" / Large',    code: 'L', desc: 'Built for riders 5\'5" to 5\'7". Full leg extension, upright comfort.' }
  };

  var result = sizeMap[height] || sizeMap['50-54'];
  var colorLabel = color === 'soft-ivory' ? 'Soft Ivory' : 'Matte Denim';

  document.getElementById('llp-quiz-size').textContent = result.size + ' in ' + colorLabel;
  document.getElementById('llp-quiz-desc').textContent = result.desc;

  var variantIds = {
    'matte-denim': { 'S': '39340588925008', 'M': '39340588957776', 'L': '39340588564560' },
    'soft-ivory':  { 'S': '39340588859472', 'M': '39340588892240', 'L': '39340588662864' }
  };
  var vid = variantIds[color] ? variantIds[color][result.code] : null;
  var ctaEl = document.getElementById('llp-quiz-cta');
  if (ctaEl && vid) {
    ctaEl.href = '/products/lorimer?variant=' + vid;
  } else if (ctaEl) {
    ctaEl.href = '/products/lorimer';
  }

  var resultBox = document.getElementById('llp-quiz-result');
  if (resultBox) {
    resultBox.style.display = 'block';
    resultBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

function lorimerQuizRestart() {
  // Clear all selections
  var allOpts = document.querySelectorAll('.llp-quiz__opt');
  for (var i = 0; i < allOpts.length; i++) { allOpts[i].classList.remove('is-active'); }
  // Hide result
  var resultBox = document.getElementById('llp-quiz-result');
  if (resultBox) resultBox.style.display = 'none';
  // Scroll back to quiz top
  var quizSection = document.getElementById('llp-size-quiz');
  if (quizSection) quizSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

/* --- Distance-Based Savings Calculator (Roebling-identical math) --- */
(function() {
  var WEEKS_PER_YEAR = 50;
  var BIKE_MPH = 12;
  var LORIMER_PRICE = 699.99;

  var flatAnnual = { bus: 600, subway: 1518 };
  var costPerMile = { driving: 0.655, rideshare: 2.1 };
  var altSpeedRatio = { subway: 0.9, bus: 0.7, rideshare: 1.1, driving: 1, mixed: 0.85 };

  function getYearCost(mode, distMi, daysPerWeek) {
    if (mode === 'mixed') {
      var busCost = (flatAnnual['bus'] / 5) * daysPerWeek;
      var rsPerTrip = distMi * costPerMile['rideshare'] * 2;
      var rsCost = rsPerTrip * daysPerWeek * WEEKS_PER_YEAR;
      return Math.round(0.6 * busCost + 0.4 * rsCost);
    }
    if (flatAnnual[mode] !== undefined) {
      return Math.round((flatAnnual[mode] / 5) * daysPerWeek);
    }
    if (costPerMile[mode] !== undefined) {
      var perTrip = distMi * costPerMile[mode] * 2;
      return Math.round(perTrip * daysPerWeek * WEEKS_PER_YEAR);
    }
    return 0;
  }

  function getDriveCost(distMi, daysPerWeek) {
    var perTrip = distMi * costPerMile['driving'] * 2;
    return Math.round(perTrip * daysPerWeek * WEEKS_PER_YEAR);
  }

  function getBikeTime(distMi) {
    return Math.round((distMi / BIKE_MPH) * 60);
  }

  function modeLabel(mode) {
    var labels = { subway: 'Subway/Metro', bus: 'Bus', rideshare: 'Rideshare', driving: 'Driving', mixed: 'Transit + rideshare' };
    return labels[mode] || mode;
  }

  window.lorimerCalcUpdate = function() {};

  window.lorimerCalcShow = function() {
    var modeEl = document.getElementById('llp-calc-mode');
    var distEl = document.getElementById('llp-calc-distance');
    var timeEl = document.getElementById('llp-calc-time');
    var daysEl = document.getElementById('llp-calc-days');

    if (!modeEl || !modeEl.value) {
      alert('Please select your current commute mode.');
      return;
    }

    var mode = modeEl.value;
    var dist = parseFloat(distEl.value) || 5;
    var currentTime = parseInt(timeEl.value, 10) || 30;
    var days = parseInt(daysEl.value, 10) || 5;

    var curCost = getYearCost(mode, dist, days);
    var driveCost = getDriveCost(dist, days);
    var bikeTime = getBikeTime(dist);

    var curModeEl = document.getElementById('llp-calc-cur-mode');
    var curCostEl = document.getElementById('llp-calc-cur-cost');
    var driveCostEl = document.getElementById('llp-calc-drive-cost');
    var bikeCostEl = document.getElementById('llp-calc-bike-cost');
    var savedEl = document.getElementById('llp-calc-saved');

    if (curModeEl) curModeEl.textContent = modeLabel(mode);
    if (curCostEl) curCostEl.textContent = '$' + curCost.toLocaleString() + '/year';
    if (driveCostEl) driveCostEl.textContent = '$' + driveCost.toLocaleString() + '/year';
    if (bikeCostEl) bikeCostEl.textContent = '$0/year';

    var maxCost = Math.max(curCost, driveCost);
    if (savedEl) savedEl.textContent = '$' + maxCost.toLocaleString();

    var resultsEl = document.getElementById('llp-calc-results');
    if (resultsEl) {
      resultsEl.style.display = 'block';
      resultsEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    var emailRow = document.getElementById('llp-calc-email-row');
    if (emailRow) emailRow.style.display = 'block';
  };

  window.lorimerCalcEmail = function() {
    var input = document.getElementById('llp-calc-email');
    if (!input) return;
    var email = input.value.trim();
    if (!email || email.indexOf('@') === -1) {
      alert('Please enter a valid email address.');
      return;
    }
    if (typeof _learnq !== 'undefined') {
      _learnq.push(['identify', { '$email': email }]);
      _learnq.push(['track', 'Lorimer Calculator Email', {
        source: 'lorimer-lp-calculator',
        ProductName: 'Lorimer',
        ProductURL: '/products/lorimer',
        Price: LORIMER_PRICE
      }]);
    }
    var form = document.getElementById('llp-calc-email-form');
    var success = document.getElementById('llp-calc-email-success');
    if (form) form.style.display = 'none';
    if (success) success.style.display = 'block';
  };
})();

function lorimerGuideCapture() {
  var input = document.getElementById('llp-guide-email');
  if (!input) return;
  var email = input.value.trim();
  if (!email || email.indexOf('@') === -1) {
    alert('Please enter a valid email address.');
    return;
  }

  var listId = window.LORIMER_GUIDE_KLAVIYO_LIST_ID || '';
  var source = window.LORIMER_GUIDE_KLAVIYO_SOURCE || 'Lorimer LP - Guide Capture';

  if (typeof _learnq !== 'undefined') {
    _learnq.push(['identify', { '$email': email }]);
    _learnq.push(['track', 'Guide Download', {
      source: source,
      guide: 'Commuter Guide',
      ProductName: 'Lorimer'
    }]);
  }

  if (listId) {
    var companyId = 'KUyM7F';
    var url = 'https://a.klaviyo.com/api/v2/list/' + listId + '/subscribe?api_key=' + companyId;
    try {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ profiles: [{ email: email, $source: source }] })
      });
    } catch(e) {}
  }

  var form = document.getElementById('llp-guide-form');
  var success = document.getElementById('llp-guide-success');
  if (form) form.style.display = 'none';
  if (success) success.style.display = 'block';
}

function lorimerScrollTo(id) {
  var el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

function lorimerFaqToggle(btn) {
  var item = btn.parentElement;
  var isOpen = item.classList.contains('llp-faq__item--open');
  var allItems = document.querySelectorAll('.llp-faq__item');
  for (var i = 0; i < allItems.length; i++) {
    allItems[i].classList.remove('llp-faq__item--open');
  }
  if (!isOpen) {
    item.classList.add('llp-faq__item--open');
  }
}

function lorimerCaptureEmail() {
  var input = document.getElementById('llp-email-input');
  if (!input) return;
  var email = input.value.trim();
  if (!email || email.indexOf('@') === -1) {
    alert('Please enter a valid email address.');
    return;
  }
  if (typeof _learnq !== 'undefined') {
    _learnq.push(['identify', { '$email': email }]);
    _learnq.push(['track', 'Lorimer LP Email Capture', { source: 'lorimer-landing-page' }]);
  }
  var wrapper = input.parentElement;
  if (wrapper) {
    wrapper.innerHTML = '<p style="color:#2c3c4c;font-weight:600;">Got it. Check your inbox for the Lorimer Commuter Guide.</p>';
  }
}

(function(){
})();
